<a class="nav-link" matRipple>
    <mat-icon class="nav-link-icon" *ngIf="item.icon">{{item.icon}}</mat-icon>
    <span class="nav-link-title" [translate]="item.translate">{{item.title}}</span>
    <span class="nav-link-badge" *ngIf="item.badge" [translate]="item.badge.translate"
          [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
        {{item.badge.title}}
    </span>
    <mat-icon class="collapse-arrow">keyboard_arrow_right</mat-icon>
</a>

<div class="children" [ngClass]="{'open': isOpen}">

    <div class="{{eCaseSettings.colorClasses.navbar}}">

        <ng-container *ngFor="let item of item.children">
            <eCase-nav-horizontal-item *ngIf="item?.itemType=='item'" [item]="item"></eCase-nav-horizontal-item>
            <eCase-nav-horizontal-collapse *ngIf="item?.itemType=='collapse'" [item]="item"></eCase-nav-horizontal-collapse>
            <eCase-nav-horizontal-collapse *ngIf="item?.itemType=='group'" [item]="item"></eCase-nav-horizontal-collapse>
        </ng-container>

    </div>

</div>
